module.exports = __webpack_public_path__ + "static/rainbowspot2-c722eb007eeca1e65a3ad2e9a1a8734c.png";